import React, { useState } from "react";
import LoaderForSearch from "../Common/LoaderForSearch";
import ReportTableHeader from "./ReportTableHeader";

function AgingReportTable(props) {
  const singleListing = props.singleListing;
  const handleScroll = props.handleScroll;
  const scrollLoader = props.scrollLoader;

  const showAgingReport = (singleListing) => {
    return (
      singleListing &&
      singleListing.map((item, key) => {
        return (
          <tr key={key}>
            <td>
              {item.clientCode === "" || undefined || null
                ? "-"
                : item.clientCode}
            </td>
            <td>
              {item.clientName === "" || undefined || null
                ? "-"
                : item.clientName}
            </td>
            <td>
              {item.totalBalance === "" || undefined || null
                ? "-"
                : item.totalBalance}
            </td>
            <td>
              {item.ageBalance === "" || undefined || null
                ? "-"
                : item.ageBalance}
            </td>
            <td>
              {item.balance === "" || undefined || null ? "-" : item.balance}
            </td>
            <td>
              {item.ageDays === "" || undefined || null ? "-" : item.ageDays}
            </td>
            <td>
              {item.sellingDate === "" || undefined || null
                ? "-"
                : item.sellingDate}
            </td>
            <td>
              {item.prcsDate === "" || undefined || null ? "-" : item.prcsDate}
            </td>
            <td>
              {item.isHolding === "" || undefined || null
                ? "-"
                : item.isHolding}
            </td>
          </tr>
        );
      })
    );
  };

  return (
    <>
      {/* <ReportTableHeader/> */}
      <div className="table-responsive scroll-table report-table-wrapper ">
        {singleListing && singleListing.length > 0 && (
          <table className="table last-column">
            <thead>
              <tr>
                <th scope="col" className="">
                  Client Code
                </th>
                <th scope="col" className="text-center">
                  Client Name
                </th>
                <th scope="col" className="text-center">
                  Total Balance
                </th>
                <th scope="col" className="text-center">
                  Age Balance
                </th>
                <th scope="col" className="text-center">
                  Balance
                </th>
                <th scope="col" className="text-center">
                  Age Days
                </th>
                <th scope="col" className="text-center">
                  Selling Date
                </th>
                <th scope="col" className="text-center">
                  Prcs Date
                </th>
                <th scope="col" className="text-center">
                  Is Holding
                </th>
              </tr>
            </thead>
            <tbody>{showAgingReport(singleListing)}</tbody>
          </table>
        )}
      </div>
    </>
  );
}
export default AgingReportTable;
